import type { FaireProductEntity } from "../../entity_types/product";

export const p_anmmvjx8f8: FaireProductEntity = {
  token: "p_anmmvjx8f8",
  type: "product",
  name: "Barre Slut Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/8d1474437f3e16115964cee94d46d616d6078d0b330377472f4218957f5d503d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/783396f58b9cfc10163d65754021fd492d254de7629f700f6953ffec602d4546.jpeg",
    "https://cdn.faire.com/fastly/bde869772797169a0856065d06d9f0bc62ea1546cdad262d961c4ffd252070aa.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/ecc327a4e38f9492d5ec1ec2f0364a02331a4ae44ffb93de927146583085f660.jpeg",
    "https://cdn.faire.com/fastly/2c2a6f7886d52e1b0e5fd6ec306bd721c4dba65833212d512a7768fff95f59fb.jpeg",
    "https://cdn.faire.com/fastly/3fde6e0954ec61ca9f07586072f637a7c18906dc592c62d64be4148f8d6d8db9.jpeg",
    "https://cdn.faire.com/fastly/78a8edfeb1337f8261b0b69eab98fdb51f2dd599561f3d310161d8bf21f9f2ae.jpeg",
    "https://cdn.faire.com/fastly/8af59bcddc056e8b50ee2124bd0bc2f3470e36ec6c0c470d74a34c2b287e9e94.jpeg"
  ],
  priceDollars: 9.6,
  description: "These grip socks are for all you baddies who spend an hour at the barre and the rest of the day walking funny.\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:26.263Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
